import type { Params, CustomerSettings } from 'app/common/components/Cafeteria/dataTypes/customer/settings'

import type { Request } from '../../../index'
import { apiLimitToString } from './helpers'


type ApiParams = {
  customer_id: number | string,
}

export const convertParams = ({ customerID }: Params): [ApiParams, null] => {
  return [{
    customer_id: parseInt(customerID, 10),
  }, null]
}

type ResultApi = {
  balance?: number
  purchase_available_on?: number
  common_limit?: number
  personal_limit?: number
  has_presales?: boolean
  has_presales_time?: boolean
  pin_activated?: boolean
  pin_enabled?: boolean
  pin_reason?: string | null
  sale_points_personal_limits: Array<{
    sale_point_id: number
    value: number | null
  }>
}

export const convertResult = ({
  balance,
  purchase_available_on: balanceAvailable,
  common_limit: commonLimit,
  personal_limit: personalLimit,
  has_presales: hasPresales,
  has_presales_time: hasPresalesTime,
  pin_activated: pinActivated,
  pin_enabled: pinEnabled,
  pin_reason: pinReason,
  sale_points_personal_limits: salePointsPersonalLimits,
}: ResultApi): CustomerSettings => {
  return ({
    balance: typeof balance === 'number' ? balance : null,
    balanceAvailable: typeof balanceAvailable === 'number' ? balanceAvailable : null,
    commonLimit: apiLimitToString(commonLimit),
    personalLimit: apiLimitToString(personalLimit),
    hasPresales: hasPresales || false,
    hasPresalesTime: hasPresalesTime || false,
    pinActivated: pinActivated || false,
    pinEnabled: pinEnabled || false,
    pinReason: typeof pinReason === 'string' ? pinReason : null,
    sellPointsPersonalLimits: salePointsPersonalLimits?.map(({ sale_point_id: sellPointID, value }) => ({
      sellPointID: String(sellPointID),
      value: apiLimitToString(value),
    })) || [],
  })
}

export const GET_CAFETERIA_CUSTOMER_SETTINGS: Request<Params, CustomerSettings, void> = [
  'cafeteria/customer/settings',
  'get',
  ['data'],
]
